import React from 'react';
import { useParams } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@eluve/components';

export const ExperimentsBreadcrumbs: React.FC = () => {
  const { experimentId } = useParams() as {
    experimentId?: string;
  };

  const isNewExperiment = experimentId === 'new';

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink text="Experiments" to="/admin/experiments" />
        </BreadcrumbItem>
        {experimentId && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink
                text={isNewExperiment ? 'New Experiment' : 'Experiment Details'}
                to={`/admin/experiments/${experimentId}`}
              />
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
